/**
 * Simple online/offline detection utility
 */

export function isOnline(): boolean {
  return navigator.onLine;
}

export function setupOnlineOfflineListeners(
  onOnline: () => void,
  onOffline: () => void
): () => void {
  window.addEventListener("online", onOnline);
  window.addEventListener("offline", onOffline);

  return () => {
    window.removeEventListener("online", onOnline);
    window.removeEventListener("offline", onOffline);
  };
}
